<template>
  <v-main>
    <v-container fluid>
      <v-row justify="center" class="mt-10">
        <v-col cols="12" md="8" class="text-center">
          <h1 class="display-1 font-weight-bold mb-3 primary--text">
            {{ $t('home.welcomeTitle') }}
          </h1>
          <p class="subtitle-1 grey--text text--darken-2">
            {{ $t('home.welcomeSubtitle') }}
          </p>
        </v-col>
      </v-row>

      <v-row justify="center" class="mt-5">
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-card elevation="2" class="fill-height rounded-lg">
            <v-card-title>
              <v-img
                :src="$t('menu.icons.engagement')"
                max-width="32"
                height="32"
                contain
                class="mr-3"
              ></v-img>
              {{ $t('home.cards.engagement.title') }}
            </v-card-title>
            <v-card-text>
              {{ $t('home.cards.engagement.text') }}
            </v-card-text>
            <v-card-actions>
              <v-btn text color="primary" :to="{ name: 'engagement-service' }">
                {{ $t('home.viewDocumentation') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="3">
          <v-card elevation="2" class="fill-height rounded-lg">
            <v-card-title>
              <v-img
                :src="$t('menu.icons.performance')"
                max-width="32"
                height="32"
                contain
                class="mr-3"
              ></v-img>
              {{ $t('home.cards.performance.title') }}
            </v-card-title>
            <v-card-text>
              {{ $t('home.cards.performance.text') }}
            </v-card-text>
            <v-card-actions>
              <v-btn text color="primary" :to="{ name: 'performance-service' }">
                {{ $t('home.viewDocumentation') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="3">
          <v-card elevation="2" class="fill-height rounded-lg">
            <v-card-title>
              <v-img
                :src="$t('menu.icons.growth')"
                max-width="32"
                height="32"
                contain
                class="mr-3"
              ></v-img>
              {{ $t('home.cards.growth.title') }}
            </v-card-title>
            <v-card-text>
              {{ $t('home.cards.growth.text') }}
            </v-card-text>
            <v-card-actions>
              <v-btn text color="primary" :to="{ name: 'growth-service' }">
                {{ $t('home.viewDocumentation') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <v-row justify="center" class="mt-5">
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-card elevation="2" class="fill-height rounded-lg">
            <v-card-title>
              <v-img
                :src="$t('menu.icons.customSurvey')"
                max-width="32"
                height="32"
                contain
                class="mr-3"
              ></v-img>
              {{ $t('home.cards.customSurveys.title') }}
            </v-card-title>
            <v-card-text>
              {{ $t('home.cards.customSurveys.text') }}
            </v-card-text>
            <v-card-actions>
              <v-btn
                text
                color="primary"
                :to="{ name: 'custom-surveys-service' }"
              >
                {{ $t('home.viewDocumentation') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="3">
          <v-card elevation="2" class="fill-height rounded-lg">
            <v-card-title>
              <v-img
                :src="$t('menu.icons.management')"
                max-width="32"
                height="32"
                contain
                class="mr-3"
              ></v-img>
              {{ $t('home.cards.documentation.title') }}
            </v-card-title>
            <v-card-text>
              {{ $t('home.cards.documentation.text') }}
            </v-card-text>
            <v-card-actions>
              <v-btn text color="primary" :to="{ name: 'management-service' }">
                {{ $t('home.viewDocumentation') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="3" v-if="false">
          <v-card elevation="2" class="fill-height rounded-lg">
            <v-card-title>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    large
                    color="secondary"
                    class="mr-3 blink-animation"
                    v-bind="attrs"
                    v-on="on"
                    >mdi-alert-circle-outline</v-icon
                  >
                </template>
                <span>{{ $t('menu.deprecatedTooltip') }}</span>
              </v-tooltip>
              {{ $t('home.cards.api.title') }}
            </v-card-title>
            <v-card-text>
              {{ $t('home.cards.api.text') }}
            </v-card-text>
            <v-card-actions>
              <v-btn text color="secondary" :to="{ name: 'apiData' }">
                {{ $t('home.viewApis') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="3" v-if="false">
          <v-card elevation="2" class="fill-height rounded-lg">
            <v-card-title>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    large
                    color="secondary"
                    class="mr-3 blink-animation"
                    v-bind="attrs"
                    v-on="on"
                    >mdi-alert-circle-outline</v-icon
                  >
                </template>
                <span>{{ $t('menu.deprecatedTooltip') }}</span>
              </v-tooltip>
              {{ $t('home.cards.apiImport.title') }}
            </v-card-title>
            <v-card-text>
              {{ $t('home.cards.apiImport.text') }}
            </v-card-text>
            <v-card-actions>
              <v-btn text color="secondary" :to="{ name: 'apiDataImport' }">
                {{ $t('home.viewApis') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import { projectAuth } from '@/firebase/config'
import { mapGetters } from 'vuex'

export default {
  name: 'HomePage',

  components: {},

  data() {
    return {}
  },

  methods: {
    async logout() {
      projectAuth.signOut().then(() => {
        this.$router.push('/logout')
      })
    },
  },
  computed: {
    ...mapGetters([
      'getUpdateYourPackageStatus',
      'getUpdateYourPackageType',
      'getExplanationNPS_Status',
      'getExplanationNPSType',
    ]),
  },
}
</script>

<style lang="scss" scoped>
.blink-animation {
  animation: blink 1.5s infinite;
}

@keyframes blink {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
}
</style>
